import React, { useState, useEffect, useRef } from "react";
import {
  AppBar,
  Box,
  Button,
  Stack,
  Tab,
  Tabs,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

import DoneIcon from "@mui/icons-material/Done";
import { Images } from "../../assets/common";
import Loader from "./../../components/Loader";
import NoData from "./../../components/Nodata";
import ApiService from "../../services/api-service";
import { fullName, getErrorString, getUserId } from "../../constants/function";
import ConfirmPopup from "./../../components/ConfirmPopup";
import notifier from "../Notifier";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
export default function NftList(props) {
  const { t } = useTranslation("common");
  const { isStream, streamData } = useSelector((state) => state.stream);
  const [message, setMessage] = useState(t("loader.message8"));
  const [type, setType] = React.useState("music");
  const [isLoading, setIsLoading] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [nfts, setNfts] = useState([]);
  const [nft, setNft] = useState("");
  const [loading, setLoading] = useState(false);
  const userId = getUserId();
  const [id, setId] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [pageNo, setPageno] = useState(1);
  const [fraction, setFraction] = useState();
  const [fractions, setFractions] = useState({});
  const [selectedFraction, setSelectedFraction] = useState([]);
  const [playlistNftIndex, setPlaylistNftIndex] = useState(null);

  const getNfts = async (page, type, emptyArray) => {
    try {
      setLoading(true);
      const response = await ApiService.ALL_NFT({
        userId: userId,
        pageSize: 16,
        pageNo: page,
        type: type,
      });
      setLoaded(response["result"].length < 16 ? true : false);
      if (emptyArray.length === 0)
        setNfts([...emptyArray, ...response["result"]]);
      else setNfts([...nfts, ...response["result"]]);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const select = (id, _id, type) => {
    if (type === "music") {
      setId(id);
      getNftFractions(_id);
    } else {
      setPlaylistNftIndex(id);
      setFraction(_id);
    }
  };
  const transferNft = async (bool, id, index) => {
    if (!bool) {
      props.onClose();
      return;
    }
    try {
      setConfirm(false);
      setIsLoading(true);
      const payload = {
        musicId: id,
        rank: fraction,
        toUser: props["toUser"],
      };
      setMessage(t("loader.message11"));
      await ApiService.GIFT_NFT_FRACTIONS(payload);
      setMessage(t("loader.message8"));
      notifier.success(t("notifier.success.toast10"));
      setIsLoading(false);
      setFraction(null);
      setId(null);
      props.onClose();
    } catch (error) {
      setConfirm(false);
      setIsLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const transferPlaylistNft = async (bool, id) => {
    if (!bool) {
      props.onClose();
      return;
    }
    try {
      setConfirm(false);
      setLoading(true);
      const payload = {
        playlistId: id,
        toUser: props["toUser"],
      };
      setMessage(t("loader.message11"));
      await ApiService.GIFT_PLAYLIST_NFT(payload);
      setMessage(t("loader.message8"));
      setPlaylistNftIndex(null);
      setFraction(null);
      notifier.success(t("notifier.success.toast10"));
      setLoading(false);
      props.onClose();
    } catch (error) {
      setConfirm(false);
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  useEffect(() => {
    setNfts([]);
  }, []);
  /**
   * cleaning local data before leaving component
   */
  useEffect(() => {
    return () => {
      setNfts([]);
      setPageno(1);
      setLoaded(false);
    };
  }, []);
  const handleScroll = async (target) => {
    var a = target.scrollTop;
    var b = target.scrollHeight - target.clientHeight;

    if ((a / b) * 100 > 80 && !loading && !loaded) {
      // run a function called doSomething
      const next = pageNo + 1;
      setPageno(next);
      getNfts(next, type, nfts);
    }
  };

  const handleSelect = (fr, i) => {
    //Handle multiple nft fraction
    // const index = fraction.indexOf(i);
    // if (index >= 0) {
    //   const f = fraction;
    //   f.splice(index, 1);
    //   setFraction([...f]);
    //   setSelectedFraction([...f]);
    // } else {
    //   const f = fraction;
    //   f.push(i);
    //   setFraction([...f]);
    //   setSelectedFraction([...f]);
    // }
    setFraction(fr == fraction ? null : fr);
  };

  const getNftFractions = async (musicId) => {
    try {
      setFractions({});
      setIsLoading(true);
      const response = await ApiService.GET_NFT_FRACTIONS(musicId);
      setFractions({ ...response["result"] });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  React.useEffect(() => {
    if (userId) {
      setLoaded(false);
      setFraction(null);
      setPageno(1);
      setPlaylistNftIndex(null);
      setId(null);
      getNfts(1, type, []);
    }
  }, [type]);
  const handleChange = (event, newValue) => {
    setId(null);
    setType(newValue === 1 ? "playlist" : "music");
  };
  return (
    <Box
      className="_nft_list_gift"
      sx={{
        position: "absolute",
        backgroundColor: "var(--paper-color, #171515)",
        zIndex: props.style ? props.style.zIndex : 1,
        width: props.style ? props.style.width : "inherit",
        bottom: "0px",
        boxShadow: "0px -6px 12px rgba(var(--background-color-rgb, 0, 0, 0), 0.35)",
        right: props.style ? props.style.right : "inherit",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        className="_chat_onlineUsers_headers"
        sx={{ padding: "8px 24px" }}
        spacing={1}
      >
        <img
          title="Close"
          style={{ width: "36px" }}
          src={Images.GIFT}
          alt="gift"
        />

        <Typography className="fs-15">Choose NFT to Gift</Typography>
        <img
          title="Close"
          style={{ width: "12px", height: "12px", marginLeft: "auto" }}
          src={Images.arrow_down}
          className="_cp"
          onClick={() => props.onClose()}
          alt="close"
        />
      </Stack>
      {/* Toggle Music nft playlist nft */}
      <AppBar position="static">
        <Tabs
          value={type === "music" ? 0 : 1}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="Choose nft type"
        >
          <Tab label="Music NFT" {...a11yProps(0)} />
          <Tab label="Studio NFT" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      {/* <ToggleButtonGroup
        sx={{ width: "100%", borderRadius: "100%" }}
        color="primary"
        value={type}
        exclusive
        onChange={(e) => {
          setId(null);
          setType(e.target.value);
        }}
      >
        <ToggleButton sx={{ width: "50%" }} value="music">
          Music NFT
        </ToggleButton>
        <ToggleButton sx={{ width: "50%" }} value="playlist">
          Playlist NFT
        </ToggleButton>
      </ToggleButtonGroup> */}
      <Stack
        onScroll={(e) => handleScroll(e.target)}
        sx={{
          height: id === null && playlistNftIndex === null ? "77%" : "70%",
          overflowY: "scroll",
        }}
      >
        {nfts.map((nft, index) =>
          isStream && streamData?._id === nft._id ? null : (
            <Stack
              key={index}
              direction="row"
              spacing={1}
              alignItems="center"
              className="_cp"
              sx={{
                height: "50px",
                padding: "5px 24px",
                backgroundColor:
                  id === index || playlistNftIndex === index
                    ? "rgba(var(--primary-color-rgb, 255, 238, 32), 0.12)"
                    : "transparent",
              }}
              onClick={() => select(index, nft["_id"], type)}
            >
              <img
                className="avatar"
                style={{
                  borderRadius: "50%",
                  border:
                    "1px solid rgba(var(--text-primary-rgb, 255, 255, 255), 0.2)",
                }}
                src={
                  nft?.GIF
                    ? nft?.GIF?.filePath
                    : nft?.thumbnailImg
                    ? nft?.thumbnailImg?.filePath
                    : type === "playlist"
                    ? Images.circle_playlist
                    : Images.circle_music
                }
                alt="gift"
              />
              <Stack direction="column" sx={{ width: "89%" }}>
                <Typography className="fs-14 fade-text-60">
                  {nft?.title}
                </Typography>
                <Stack
                  direction="row"
                  style={{
                    overflowX: "scroll",
                    gap: "6px",
                    width: nft?.artistData?.length > 1 ? "57%" : "",
                  }}
                >
                  {nft?.artistData ? (
                    nft.artistData.length > 1 ? (
                      nft.artistData.map((a, index) => (
                        <Typography
                          className="fs-13 fade-text-60"
                          style={{ lineHeight: "1", whiteSpace: "nowrap" }}
                          key={index}
                        >
                          {a?.displayArtistName}
                          {nft.artistData.length - 1 == index ? "" : ","}
                        </Typography>
                      ))
                    ) : (
                      nft.artistData.map((a, index) => (
                        <Typography
                          className="fs-13 fade-text-60"
                          style={{ lineHeight: "1", whiteSpace: "nowrap" }}
                          key={index}
                        >
                          {a?.displayArtistName}
                        </Typography>
                      ))
                    )
                  ) : (
                    <Typography className="fs-13 fade-text-60">
                      {nft?.artist}
                    </Typography>
                  )}
                </Stack>
              </Stack>
              {id === index || playlistNftIndex === index ? (
                <img
                  style={{ marginLeft: "auto" }}
                  src={Images.done}
                  alt="done"
                />
              ) : null}
            </Stack>
          )
        )}
      </Stack>
      {id !== null || playlistNftIndex !== null ? (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            height: "40px",
            padding: "0 10px 0 24px",
            boxShadow: "0px -6px 12px rgba(var(--background-color-rgb, 0, 0, 0), 0.35)",
            position: "absolute",
            bottom: "0",
            width: "90%",
          }}
        >
          <input
            style={{
              border: "none",
              height: "inherit",
              backgroundColor: "transparent",
              color: "var(--text-primary, #ffffff)",
              width: "100%",
              fontSize: "14px",
              cursor: "default",
            }}
            readOnly
            placeholder="Send NFT as Gift"
          />
          <img
            title="transfer nft"
            aria-label="Nft rank"
            className="__sent_botton _cp"
            src={!fraction ? Images.send : Images.send_active}
            onClick={() => (fraction ? setConfirm(true) : setConfirm(false))}
            alt="send"
          />
        </Stack>
      ) : null}
      {loading ? (
        <Loader wait={true} _class="__loader_inside" message={message} />
      ) : null}
      {confirm ? (
        <ConfirmPopup
          open={confirm}
          handleClose={(bool, _id, index) =>
            type === "music"
              ? transferNft(bool, _id, index)
              : transferPlaylistNft(bool, _id)
          }
          id={
            type === "playlist"
              ? nfts[playlistNftIndex]["_id"]
              : nfts[id]["_id"]
          }
          index={playlistNftIndex ? playlistNftIndex : id}
          message={`${t("confirmPopup.text5")} "${
            nfts[type === "playlist" ? playlistNftIndex : id]["title"]
          }" ${t("confirmPopup.text6")} "${props["fullName"]}" ?`}
        />
      ) : null}
      {id !== null ? (
        <Box className="_nft_fractions">
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{ paddingTop: "20px" }}
          >
            <Typography className="fs-17">Available NFT Fractions</Typography>
            <Typography className="fs-17">
              {fractions["availableFractions"] || 0}/
              {fractions["totalFractions"] || 0}
            </Typography>
          </Stack>
          <Stack className="_nft_fractions_box">
            {fractions["fractions"] &&
              fractions["fractions"].map((f, index) => (
                <Typography
                  onClick={() => handleSelect(f, index)}
                  className={
                    "_fraction " + (fraction === f ? "_fraction_selected" : "")
                  }
                  key={index}
                >
                  {f}
                </Typography>
              ))}
          </Stack>
          {isLoading ? (
            <Loader _class="__loader_inside" wait="true" message={message} />
          ) : null}
        </Box>
      ) : null}
    </Box>
  );
}
